const getEnv = () => {
	return {
		API_ENDPOINT_URL: process.env.REACT_APP_API_URL
	}
}

export const env = getEnv()
